export default __webpack_public_path__ + "static/media/insta_dexpro3.75021e4f.png";